import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  ReplacementOffer,
  UpfrontPaymentSummary,
} from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderDetailsComponent {
  @Input() upfront: UpfrontPaymentSummary;
  @Input() selected: ReplacementOffer;
}
